import type {
  IAddHashKeyManagerPayload,
  IAddHashKeyManagerResponse,
  IBatchDeleteHashKeysPayload,
  IBatchDeleteHashKeysResponse,
  IRemoveApiKeyFromHashKeyPayload,
  IRemoveApiKeyFromHashKeyResponse,
  ILoginWithHashKeyPayload,
  ILoginWithHashKeyResponse,
  IAddApiKeyToHashKeyPayload,
  IAddApiKeyToHashKeyResponse,
  IRenameHashKeyResponse,
  IRenameHashKeyPayload,
} from "../types/hash.types";
import axios from "@/hooks/axios/axios";
import authAxios from "@/hooks/axios/authAxios";

export const addHashKey = async (
  payload: IAddHashKeyManagerPayload,
): Promise<IAddHashKeyManagerResponse> => {
  const { data } = await axios.post("/hash-keys/create", payload);
  return data;
};

export const loginWithHashKey = async (
  payload: ILoginWithHashKeyPayload,
): Promise<ILoginWithHashKeyResponse> => {
  const { data } = await authAxios.post("/auth/login/hash-key", payload, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return data;
};

// Unified Token Overview
export const getHashKeys = async () => {
  const { data } = await axios.get(
    "/hash-keys?page=1&page_size=100&active_only=false",
  );
  return data;
};

export const batchDeleteHashKeys = async (
  payload: IBatchDeleteHashKeysPayload,
): Promise<IBatchDeleteHashKeysResponse> => {
  const { data } = await axios.post(
    "/hash-keys/bulk-deactivate",
    payload.hash_key_ids,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  return data;
};

export const removeApiKeyFromHashKey = async (
  payload: IRemoveApiKeyFromHashKeyPayload,
): Promise<IRemoveApiKeyFromHashKeyResponse> => {
  const { data } = await axios.post(
    `/hash-keys/${payload.hash_key_id}/remove-api-key`,
    { api_key_id: payload.api_key_id },
  );
  return data;
};

export const addApiKeyToHashKey = async (
  payload: IAddApiKeyToHashKeyPayload,
): Promise<IAddApiKeyToHashKeyResponse> => {
  const { data } = await axios.post(
    `/hash-keys/${payload.hash_key_id}/add-api-key`,
    { api_key_id: payload.api_key_id },
  );
  return data;
};

export const renameHashKey = async (
  payload: IRenameHashKeyPayload,
): Promise<IRenameHashKeyResponse> => {
  const { data } = await axios.patch(
    `/hash-keys/${payload.hash_key_id}`,
    { description: payload.description },
    { params: { hash_key_name: payload.name } },
  );
  return data;
};
